import type { SpringError } from "@p-ban/common/src/core/api/createHttpClient"
import type { Optional } from "@p-ban/common/src/types"

import type { ManufactureCourse } from "../../features/oneClickEstimate/constant/manufactureCourse"
import httpClient from "../httpClient"
import type { EstimateSuccessResult } from "./csComEst.d"

export const END_POINT = {
  DELETE_DRC_DATA: "/kiban/api/estimate/delete-drc-data",
  SAVE: "/kiban/api/estimate/save",
  VALIDATE: "/kiban/api/estimate/individual/validate",
} as const

export type EstimateSaveResult = {
  title: string
  estimateNo: {
    key: string
    display: string
  }
}

type EstimateSaveParams = {
  title: string
  manufactureCourse: ManufactureCourse
  estimateParameter: EstimateSuccessResult["summaryTrialPurchaseParam"]
  estimateResult: EstimateSuccessResult["summaryTrialPurchaseResult"]
  bomSnapshotId: number | null
  deliveryZeroFlg: boolean
  mountQuickFlg: boolean
} & Optional<{
  remarks: string
  files: File[]
}>

const estimateApi = {
  deleteDrcData() {
    return httpClient.delete(END_POINT.DELETE_DRC_DATA)
  },
  save(data: EstimateSaveParams) {
    const payload = {
      ...data,
      manufactureCourse: data.manufactureCourse.value,
    }

    const formData = new FormData()
    const { files, ...properties } = payload
    formData.append("properties", new Blob([JSON.stringify(properties)], { type: "application/json" }))
    files?.forEach((file) => {
      formData.append("files", file)
    })

    return httpClient.post<EstimateSaveResult, SpringError<typeof payload>>(END_POINT.SAVE, formData)
  },
  validate(data: { title: string; files: File[] }) {
    const payload = {
      title: data.title,
      filesMetaData: data.files.map((file) => ({ name: file.name, size: file.size })),
    }
    return httpClient.post<"", SpringError<typeof payload>>(END_POINT.VALIDATE, payload)
  },
}

export default estimateApi
